import React from 'react'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import { BreakPoint } from 'src/components/shared/CssValues'
import HeadLine from 'src/components/atoms/HeadLine'
import { Typography } from 'src/components/atoms/Typography'

const CompanyInformation = () => {
  return (
    <ContentsWrapper>
      <Contents>
        <HeadingBorder heading="INFORMATION" />
        <HeadLine>基本情報</HeadLine>
        <InformationList>
          <InformationListItem top>
            <InformationTitle as="p">会社名</InformationTitle>
            <InformationText as="p">
              コミューン株式会社 (Commmune Inc.)
            </InformationText>
          </InformationListItem>
          <InformationListItem>
            <InformationTitle as="p">所在地</InformationTitle>
            <InformationText as="p">
              〒141-0031 東京都品川区西五反田4-31-18
              <br />
              目黒テクノビル2F
            </InformationText>
          </InformationListItem>
          <InformationListItem>
            <InformationTitle as="p">設立</InformationTitle>
            <InformationText as="p">2018年5月</InformationText>
          </InformationListItem>
          <InformationListItem>
            <InformationTitle as="p">取締役</InformationTitle>
            <InformationText as="p">
              高田優哉 (代表取締役CEO)
              <br />
              橋本翔太 (取締役CPO)
              <br />
              山本晃大 (取締役CTO)
            </InformationText>
          </InformationListItem>
          <InformationListItem>
            <InformationTitle as="p">資本金</InformationTitle>
            <InformationText as="p">24.4億円 (資本剰余金含む)</InformationText>
          </InformationListItem>
        </InformationList>
        <GoogleMap
          frameBorder="0"
          scrolling="no"
          marginHeight={0}
          marginWidth={0}
          width="100%"
          height="360"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.180492103606!2d139.7206449152573!3d35.623276680207844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x31314ca668c6cb7d!2z44Kz44Of44Ol44O844Oz5qCq5byP5Lya56S-!5e0!3m2!1sja!2sjp!4v1568121871839!5m2!1sja!2sjp;t=m&amp;z=15&amp;output=embed&amp;iwloc=near"
          aria-label="東京都品川区西五反田4-31-18 目黒テクノビル2F"
        />
      </Contents>
    </ContentsWrapper>
  )
}

const Contents = styled.div`
  margin: 120px 0;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin: 80px 0;
  }
`

const InformationList = styled.div`
  width: 670px;
  margin: 50px auto;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const InformationListItem = styled.div`
  display: flex;
  padding: 30px 0;
  border-top: ${({ top }: { top?: boolean }) =>
    top ? 'none' : 'solid 1px #D1D1D1'};
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    flex-direction: column;
    width: 100%;
  }
`

const InformationTitle = styled(Typography)`
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.73;
  letter-spacing: 1.2px;
  text-align: left;
  color: #333333;
  width: 65px;
`

const InformationText = styled(Typography)`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.73;
  letter-spacing: 1.2px;
  text-align: left;
  color: #333333;
  margin-left: 120px;
  width: ${BreakPoint.SMARTPHONE_MAX_WIDTH};
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-left: 0;
    width: 100%;
  }
`

const GoogleMap = styled.iframe``

export default CompanyInformation
